module.exports = __webpack_public_path__ + "static/img/footer-robot.16ee802.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/footer-robot.png
// module id = zSgx
// module chunks = 1